import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import { Item, FlagType, Revision as RadarRevision } from "../../../model";
import {
  GetRadarQuery,
  Capability,
  FilterTag,
  Person,
  Revision,
} from "../../../generated/graphql";

const stringsFromArray = (
  array: Capability[] | FilterTag[] | undefined | null
) => {
  const strings: string[] = [];
  if (array) {
    for (var item of array) {
      if (item.title) {
        strings.push(item.title);
      }
    }
  }
  return strings ?? [];
};

const buildRevisions = (data: Revision[]) => {
  const revisions: RadarRevision[] = [];

  for (var revision of data) {
    revisions.push({
      featured: true,
      quadrant: "quadrant1",
      title: "",
      name: "",
      release: revision.date,
      ring: revision.ring ?? "",
      body: documentToHtmlString(revision.update?.json) || "",
    });
  }

  return revisions;
};

export const dataRadarTransform = (query: GetRadarQuery) => {
  const data = query.pages?.items[0];
  const items: Item[] = [];

  if (data) {
    const quadrants = [
      { name: "quadrant1", blips: data?.quadrant1?.blipListCollection?.items },
      { name: "quadrant2", blips: data?.quadrant2?.blipListCollection?.items },
      { name: "quadrant3", blips: data?.quadrant3?.blipListCollection?.items },
      { name: "quadrant4", blips: data?.quadrant4?.blipListCollection?.items },
    ];

    for (var quadrant of quadrants) {
      if (quadrant && quadrant.blips) {
        for (var blip of quadrant.blips) {
          items.push({
            flag: FlagType.default,
            featured: true,
            name: blip?.title ?? "",
            title: blip?.title ?? "",
            ring: blip?.revisionsCollection?.items[0]?.ring ?? "hold",
            quadrant: quadrant.name,
            body:
              documentToHtmlString(
                blip?.revisionsCollection?.items[0]?.update?.json
              ) || "empty",
            info: blip?.shortInfo || "",
            revisions: buildRevisions(
              blip?.revisionsCollection?.items as Revision[]
            ),
            capabilities: stringsFromArray(
              blip?.capabilitiesCollection?.items as Capability[]
            ),
            people: blip?.peopleCollection?.items as Person[],
          });
        }
      }
    }
  }
  return { items };
};
